import { useQuery } from '@tanstack/react-query'
import { EventsQueryKeys } from '@/modules/events/keys'
import { getTurnoverEventById } from '../../services'

export default function useQueryGetTurnoverEventById(
	id: string,
	enabled = true,
) {
	return useQuery({
		queryKey: [EventsQueryKeys.getTurnoverEventById, id],
		queryFn: () => getTurnoverEventById(id),
		enabled: enabled && !!id,
	})
}
